import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';

@Component({
  selector: 'app-forecast-information',
  templateUrl: './forecast-information.component.html',
  styleUrls: ['./forecast-information.component.scss']
})
export class ForecastInformationComponent implements OnInit {

  closeResult = '';

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;

  dtOptions: DataTables.Settings = {};

  listPayToday = [];
  listPayPast = [];
  
  constructor(config: NgbModalConfig, private modalService: NgbModal, private http: HttpClient,
    private spinner: NgxSpinnerService, private errorService:ErrorService) {

    config.backdrop = 'static';
    config.keyboard = false;
   }

  ngOnInit(): void {
    this.dtOptions = FormatDataTableGlobalFive();
  }

  public open(item) {

    this.listPayToday = item.listPayToday
    this.listPayPast = item.listPayPast

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}

